import Axios from 'axios';
import { urlConfig } from 'api/url';
import {
  getParams, setAuthorizationHeaders, setHeaders,
} from 'api/utils';

const { baseUrl, homeDeliveryV1, newOOBaseUrl } = urlConfig;
const productDetail = () => `${newOOBaseUrl}/search/store/product-details`;
const comboOfferDetail = (comboId) => `${newOOBaseUrl}offers/combo-offer/${comboId || ''}`;
const productShop = (productId) => `${baseUrl}${homeDeliveryV1}/productshop/${productId || ''}`;
const relatedProduct = (productId) => `${baseUrl}${homeDeliveryV1}/relatedproduct/${productId || ''}`;
const relatedOffers = () => `${baseUrl}${homeDeliveryV1}/specialoffers/`;
const alsoBought = (productId) => `${baseUrl}${homeDeliveryV1}/alsobought/${productId || ''}`;
const getChildCategory = (productId) => `${baseUrl}${homeDeliveryV1}/activechildcategory/${productId || ''}`;
const getNearbyStores = () => `${baseUrl}${homeDeliveryV1}/nearbyshops/`;

export const productDetailsApi = (method, cancelToken, latitude, longitude, productId, storeId) => (
  Axios({
    url: productDetail(productId),
    method,
    params: getParams({
      latitude, longitude, productId, storeId,
    }),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);

export const comboOfferDetailApi = (method, cancelToken, productId, cartId) => (
  Axios({
    url: comboOfferDetail(productId),
    method,
    params: getParams({ cartId }),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);

export const exploreShopsApi = (method, cancelToken, location, productId) => (
  Axios({
    url: productShop(productId),
    method,
    params: getParams({ latlng: location }),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);

export const relatedProductApi = (method, cancelToken, params, productId) => (
  Axios({
    url: relatedProduct(productId),
    method,
    params: getParams(params),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);

export const alsoBoughtApi = (method, cancelToken, location, productId) => (
  Axios({
    url: alsoBought(productId),
    method,
    params: getParams({ location }),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);

export const getCatApi = (method, cancelToken, location, productId) => (
  Axios({
    url: getChildCategory(productId),
    method,
    params: getParams({ location }),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);

export const getNearbySToreApi = (method, cancelToken, location) => (
  Axios({
    url: getNearbyStores(),
    method,
    params: getParams({ location }),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);

export const getRelatedOffersApi = (method, cancelToken, params) => (
  Axios({
    url: relatedOffers(),
    method,
    params: getParams(params || {}),
    headers: setHeaders(setAuthorizationHeaders()),
    cancelToken,
  })
);
